// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_B1nau){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_pwHGB .dualColumn_1jLuf{display:flex;align-content:space-between}.nsAddressForm_pwHGB .dualColumn_1jLuf .firstCol_1aQ8f{margin-right:20px}.optional_1K4S2{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_B1nau",
	"nsAddressForm": "nsAddressForm_pwHGB",
	"dualColumn": "dualColumn_1jLuf",
	"firstCol": "firstCol_1aQ8f",
	"optional": "optional_1K4S2"
};
module.exports = exports;
